/* eslint-disable @typescript-eslint/default-param-last */
import { GET_CAMPAIGNS } from '../../constants/ActionTypes';
import { ActionType } from '../../types/Interviews/interviews.types';
import { IDhwaniDashboardData } from '../../types/dhwani/dashboard.types';

interface DhwaniDashboardAction {
  type: string;
  payload: IDhwaniDashboardData;
}

/**
 * Campaigns Reducer
 * @param {IDhwaniDashboardData | null} state
 * @param {DhwaniDashboardAction} action
 * @returns {IDhwaniDashboardData | null}
 */
const campaignsReducer = (
  state: IDhwaniDashboardData | null = null,
  action: DhwaniDashboardAction | ActionType
): IDhwaniDashboardData | null => {
  switch (action?.type) {
    case `${GET_CAMPAIGNS}_SUCCESS`:
      return action.payload as IDhwaniDashboardData;
    default:
      return state;
  }
};

export default campaignsReducer;
